// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-img-top
{
  width: 50%;
  height: 50%;
  margin: 85px;
}
:host nb-card{
  width: 50rem;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNpbXVsYXRpb24tdHlwZS1kaWFsb2cuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7RUFFRSxVQUFVO0VBQ1YsV0FBVztFQUNYLFlBQVk7QUFDZDtBQUNBO0VBQ0UsWUFBWTtBQUNkIiwiZmlsZSI6InNpbXVsYXRpb24tdHlwZS1kaWFsb2cuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5jYXJkLWltZy10b3BcbntcbiAgd2lkdGg6IDUwJTtcbiAgaGVpZ2h0OiA1MCU7XG4gIG1hcmdpbjogODVweDtcbn1cbjpob3N0IG5iLWNhcmR7XG4gIHdpZHRoOiA1MHJlbTtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/core/components/dialog/simulation-type-dialog/simulation-type-dialog.component.css"],"names":[],"mappings":"AAAA;;EAEE,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA,oeAAoe","sourcesContent":[".card-img-top\n{\n  width: 50%;\n  height: 50%;\n  margin: 85px;\n}\n:host nb-card{\n  width: 50rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
